import React from "react";
import {Tabs} from "antd";

export type SizeEnum =  'small' | 'middle' | 'large' | undefined;
export type PositionEnum = 'left' | 'right' | 'top' | 'bottom';

type Items = {
    label: string,
    key: string,
    children?: JSX.Element
}

export type JTabsProps = {
    items?: Items[],
    defaultKey?: string,
    size?: SizeEnum,
    tabPosition?: PositionEnum,
    onTabClick?:any
    className?:string;
    handleOnChange?: (str: string)=> void;
    activeKey?: string;
}

export const JTabs = ({
                          items,
                          defaultKey = '0',
                          activeKey,
                          size = 'middle',
                          tabPosition = 'top',
                          onTabClick,
                          handleOnChange,
                          className}: JTabsProps) => {
    return(<Tabs
        activeKey={activeKey}
        items={items}
        size={size}
        defaultActiveKey={defaultKey}
        tabPosition={tabPosition}
        onTabClick={onTabClick}
        className={className}
        onChange={handleOnChange}
    />)
}